import { config } from 'lib-shared-backend-config';

/**
 * URL to the article css.
 *
 * This comes from `src/assets/css/article/#version#.
 *
 * The no rems option is for the agent interface as they don't currently have
 * the root fontsize set.
 */
export function articleCssCDN({
  cssVersion = '1.3.0',
  noREMs = false,
}: {
  cssVersion?: string;
  noREMs?: boolean;
} = {}): string {
  // use newer css files.
  const _cssVersion =
    cssVersion === '1.0.0' || cssVersion === '1.1.0' ? '1.3.0' : cssVersion;
  const filename = noREMs ? 'article-no-rems.css' : 'article.css';
  const path = `css/article/${_cssVersion}`;

  if (config.environment === 'prod') {
    return `https://knowledge.dixa.io/assets/${path}/${filename}`;
  }
  return `https://knowledge.stag.dixa.io/${path}/${filename}`;
}
